import React from 'react'
import { Route, Routes } from 'react-router-dom'
import InsertsLayout from '../layout/inserts/InsertsLayout'
import InsertsPageLayout from "../layout/inserts/InsertsPageLayout";

function InsertsPage() {
    return (
        <Routes>
            <Route path="/" element={<InsertsLayout />} />
            <Route path="/layout/page/:id" element={<InsertsPageLayout />} />
        </Routes>
    )
}

export default InsertsPage
